'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002424 from "./presto.-Dashboard-View$$anon$24.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSign$002dStats$0024 from "./presto.types$-Dashboard-Sign-Stats$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$23() {
  this.aLv = null;
  this.aLn = null;
  this.aLo = false;
  this.aLw = null;
  this.aLx = false;
  this.aLA = null;
  this.aLt = null;
  this.aLu = false;
  this.aLp = null;
  this.aLq = false;
  this.aLr = null;
  this.aLs = false;
  this.aLy = false;
  this.aLz = false;
  this.aLv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aLA = "DashboardSignStats";
}
export { $c_Lpresto_DashboardView$$anon$23 as $c_Lpresto_DashboardView$$anon$23 };
$p = $c_Lpresto_DashboardView$$anon$23.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$23;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$23() {
}
export { $h_Lpresto_DashboardView$$anon$23 as $h_Lpresto_DashboardView$$anon$23 };
$h_Lpresto_DashboardView$$anon$23.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aLv;
});
$p.M = (function() {
  if ((!this.aLo)) {
    this.aLn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aLo = true;
  }
  return this.aLn;
});
$p.O = (function() {
  if ((!this.aLx)) {
    this.aLw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aLx = true;
  }
  return this.aLw;
});
$p.D = (function() {
  return this.aLA;
});
$p.t = (function() {
  if ((!this.aLu)) {
    this.aLt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("signatures", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("envelopes", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aLu = true;
  }
  return this.aLt;
});
$p.N = (function() {
  if ((!this.aLq)) {
    this.aLp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aLq = true;
  }
  return this.aLp;
});
$p.Q = (function() {
  if ((!this.aLs)) {
    this.aLr = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002424.$c_Lpresto_DashboardView$$anon$24();
    this.aLs = true;
  }
  return this.aLr;
});
$p.v = (function() {
  if ((!this.aLz)) {
    this.aLy = false;
    this.aLz = true;
  }
  return this.aLy;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee124) => ((p) => \u03b4scrutinee124.cHr(p)))($j_presto$002etypes$0024$002dDashboard$002dSign$002dStats$0024.$m_Lpresto_types$DashboardSignStats$())));
});
var $d_Lpresto_DashboardView$$anon$23 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$23, "presto.DashboardView$$anon$23", ({
  GX: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$23 as $d_Lpresto_DashboardView$$anon$23 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$23.js.map
